import React from 'react';
import Layout from '../../components/Layout';
import LoginContent from '../../components/content/Login';
import Sponsor from '../../components/Sponsor';
import { props } from 'tcomb-react';
import t from 'tcomb-form';

@props({
  locale: t.Obj,
  message: t.maybe(t.ReactElement),
  goResendPassword: t.Func,
  doLogin: t.Func,
  goFacebookLogin: t.Func,
  goGoogleLogin: t.Func,
  goTwitterLogin: t.Func,
  goMicrosoftLogin: t.Func,
  doAcceptCookies: t.Func,
  goRegister: t.maybe(t.Func)
})
export default class Login extends React.Component {

  getHeader() {

    return (
      <div id='login_header'>
        <div className='cols'>
          <div className='large-100 large-text-right'>
          </div>
        </div>
      </div>
    );
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor locale={this.props.locale} options={options} />);
  }

  render() {
    const locale = this.props.locale;
    return (
      <Layout locale={locale} header={this.getHeader()} sponsor={this.getSponsor()} doAcceptCookies={this.props.doAcceptCookies}>
        <LoginContent
          locale={locale}
          message={this.props.message}
          doLogin={this.props.doLogin}
          goResendPassword={this.props.goResendPassword}
          goFacebookLogin={this.props.goFacebookLogin}
          goGoogleLogin={this.props.goGoogleLogin}
          goTwitterLogin={this.props.goTwitterLogin}
          goMicrosoftLogin={this.props.goMicrosoftLogin} />
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/user/route/Login.js
 **/